import { InlineScript } from '@lcms/react-scripts';

export function GoogleTagManager({ googleTagManagerId }: { googleTagManagerId?: string | null; }) {
    if (!googleTagManagerId) {
        return null;
    }

    return (
        <InlineScript
            type="text/javascript"
            code={`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${googleTagManagerId}');`}
        />
    );
}